import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpErrorHandlerService } from '../httpErrorHandlerService/http-error-handler.service';
import { Labels } from 'src/app/labels/englishLabels';
import { NotificationsService } from '../../infra/notifications/notifications.service';
import { LoggerService } from '../../infra/logger/logger.service';

@Injectable({
  providedIn: 'root',
})
export class InventoryResourceRequestHttpErrorHandlerService extends HttpErrorHandlerService {
  constructor(_loggerService: LoggerService, _notificationService: NotificationsService) {
    super(_loggerService, _notificationService);
  }

  public override handle(error: HttpErrorResponse, useErrorMessage = false): void {
    if (error.status === 404) {
      this._notificationService.error(Labels.errors.inventory404ResourceMightBeDeletedError);
    } else {
      super.handle(error, useErrorMessage);
    }
  }
}
